import { BasicLayout } from "../../modules/Layouts/basicLayout";

import BackIcon from '../../media/felsv/dark_delete_file_icon.svg'

export default function ExportacionDetalle (){

    return (
        <BasicLayout>
            <div>detalle exportacion</div>
        </BasicLayout>
    )
}